import {extendTheme} from '@chakra-ui/react'

const theme = extendTheme({
  fonts: {
    heading: `Cooper, serif`,
    body: `Graphik, sans-serif`,
  },
})

export default theme
